import AxiosProvider from '@/api/provider/axios';
import BaseApi from '@/api/base-api';
import type { HttpProvider } from '@/api/http-provider';

class Api extends BaseApi {
    constructor(provider?: HttpProvider) {
        super(provider ?? new AxiosProvider());
    }
}

export default Api;

export const instance = new Api();
